export default {
  watch: {
    preMessage: {
      handler (value) {
        this.updateMessage(value)
      }
    },
    messageProps: {
      handler (value) {
        this.updateMessageProps(value)
      }
    }
  },
  methods: {
    messageComponents () {
      const message = this.preMessage
      const messageProps = this.messageProps
      const updateMessage = this.updateMessage
      const updateMessageProps = this.updateMessageProps

      if (!AFRAME.components.premessage) {
        AFRAME.registerComponent('premessage', {
          init () {
            updateMessage(message)
            updateMessageProps(messageProps)
          },
          remove () {
            delete AFRAME.components.premessage
          }
        })
      }
    },
    getElements () {
      const elements = {}
      elements.wrapper = document.querySelector('[premessage]')
      elements.wrapperAttribution = document.querySelector(
        '[wrapper-attribution]'
      )

      elements.polyAttribution = document.querySelector('[polygon-attribution]')
      return elements
    },
    updateMessage (message) {
      const preMessageElement = document.querySelector('[premessage]')
      if (message !== '') {
        preMessageElement.setAttribute('visible', 'true')
        preMessageElement.setAttribute('text', 'value', message)
      } else {
        preMessageElement.setAttribute('visible', 'false')
      }
    },
    updateMessageProps (messageProps) {
      const elements = this.getElements()
      if (elements && elements.wrapper) {
        elements.wrapper.setAttribute('text', 'color', messageProps.text)
        elements.wrapper.setAttribute('text', 'width', messageProps.fontSize)

        elements.wrapperAttribution.setAttribute(
          'text',
          'color',
          messageProps.text
        )

        elements.wrapper.setAttribute(
          'material',
          'color',
          messageProps.background
        )
        elements.polyAttribution.setAttribute(
          'text',
          'color',
          messageProps.text
        )

        // elements.wrapper.setAttribute(
        //   'position',
        //   `${messageProps.positionX}, ${messageProps.positionY}, -11`
        // )
      }
    }
  }
}
